<template>
  <div>
    <PageHeader />
    <ProjInfo :projectInfo="projectInfo" :changelog="changelog" />


    <v-container class="section-block">
        <v-row>
            <v-col class="col-12 col-md-6 col-sm-6">
                <h3>Usage simplicity</h3>
                    <li>Select a path or mask and click the button</li>
                <p>
                    That's all there is. Controllers will be created for each vertex of the path. 
                    Repositon and keyframe these controllers to animate edges and corners with a new level of control. 
                </p>
                <p>
                    This is not all that different from the <b>Create Nulls from Paths</b> script that comes bundled with Ae, 
                    but Radness is built to handle many more alignment situations and prioritizes <i>shape layers</i> over <i>nulls</i>.
                </p>
                <p>
                    If you don't yet understand why nulls are awful, message me at <b>adamplouff@</b> and I will be happy to 
                    share the good news of <i>asset-free-project-collection</i> with you.
                </p>
            </v-col>
            <v-col class="col-12 col-md-4 col-sm-6">
                <img :src="images.ui" width="100%" alt="">
            </v-col>
            </v-row>
            <v-row>
            <v-col class="col-12 col-md-4">
                <h3>Scale = rounding</h3>
                <p>
                    The main point of <b>Radness</b> is corner rounding. Each newly created controller not only controls a point's position, 
                    but also the roundness of the corner.  
                </p>
                <p>
                    Adjust the controller's <b>scale</b> property to add roundness to the corner. 
                </p>
                <ul>
                    <li>0% scale = sharp corner</li>
                    <li>10% scale = 10px corner radius</li>
                    <li>100% scale = 100px corner radius</li>
                    <li>480% scale = 480px corner radius</li>
                </ul>
            </v-col>
            <v-col class="col-12 col-md-8">
                <video width="100%" :src="video.tutorial" controls></video>
            </v-col>
        </v-row>


    </v-container>

    <!-- <InstallInfo id="install" :projectInfo="projectInfo"/> -->
    <InstallInfo id="install" name="Radness" scriptUI :hosts="['After Effects']"/>


    <Changelog :changelog="changelog" />        
            
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'conclave',
  components: {
  },
  data: () => ({
      images: {
            ui: require('../assets/images/Radness.jpg'),
        },
        video: {
            tutorial: require('../assets/video/Radness_01.mp4'),
        },
      projectInfo: {
          name: 'Radness',
          subtitle: 'Independent corner rounding for paths',
            source: true,
          about: `Animate the points of a path or mask independently and take control of each corner's rounding radius just like Figma and other design apps.`
      },
      changelog: [
          {
              version: '0.1.5',
              date: 'March 08, 2022',
              fixed: [
                  'Selecting a path in 2022 selects the grandparent group',
                ],
          },
          {
              version: '0.1.4',
              date: 'July 14, 2021',
              changed: [
                  'Scale compensation for parented controllers',
                  'Controllers created above the target layer'
                ],
          },
          {
              version: '0.1.3',
              date: 'June 21, 2021',
              fixed: [
                  'Controllers set to double size'
                ],
          },
          {
              version: '0.1.2',
              date: 'March 26, 2021',
              comment: ['Initial release'],
          },
      ]
  }),
}
</script>